import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from 'recharts';
import styles from './Charts.module.css';

interface Props {
  data: Array<{ month: string; profileViews: number; catalogViews: number }>;
  title?: string;
}

export function ViewsAreaChart({ data, title }: Props) {
  if (data.length === 0) {
    return <div className={styles.empty}>No data</div>;
  }

  const labeled = data.map((d) => ({
    ...d,
    label: d.month.slice(2),
  }));

  return (
    <div className={styles.chartCard}>
      <h3 className={styles.chartTitle}>{title ?? 'Views'}</h3>
      <div className={styles.chartWrap}>
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={labeled} margin={{ top: 8, right: 8, bottom: 8, left: 0 }}>
            <defs>
              <linearGradient id="viewsProfile" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="var(--accent)" stopOpacity={0.3} />
                <stop offset="95%" stopColor="var(--accent)" stopOpacity={0} />
              </linearGradient>
              <linearGradient id="viewsCatalog" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="var(--chart-2, #FFB800)" stopOpacity={0.3} />
                <stop offset="95%" stopColor="var(--chart-2, #FFB800)" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
            <XAxis dataKey="label" tick={{ fill: 'var(--text-secondary)', fontSize: 11 }} axisLine={{ stroke: 'var(--border)' }} tickLine={false} />
            <YAxis allowDecimals={false} tick={{ fill: 'var(--text-secondary)', fontSize: 11 }} axisLine={{ stroke: 'var(--border)' }} tickLine={false} />
            <Tooltip contentStyle={{ background: 'var(--bg-secondary)', border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)', color: 'var(--text-primary)', fontSize: '0.75rem' }} />
            <Legend wrapperStyle={{ fontSize: '0.7rem', color: 'var(--text-secondary)' }} />
            <Area type="monotone" dataKey="profileViews" name="Profile Views" stroke="var(--accent)" fill="url(#viewsProfile)" strokeWidth={2} stackId="views" />
            <Area type="monotone" dataKey="catalogViews" name="Catalog Views" stroke="var(--chart-2, #FFB800)" fill="url(#viewsCatalog)" strokeWidth={2} stackId="views" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
